export const TIPOS_PERSONAL = [
  { value: "docente",        label: "Docente" },
  { value: "administrativo", label: "Administrativo" },
  { value: "servicios",      label: "Servicios" },
];

export const TIPOS_CONTRATACION = [
  { value: "nomina",    label: "Nómina" },
  { value: "servicios", label: "Servicios (factura)" },
  { value: "hibrido",   label: "Híbrido" },
];

export const ESTADOS_EMPLEADO = [
  { value: "activo",   label: "Activo" },
  { value: "inactivo", label: "Inactivo" },
];

export const initialEmpleadoForm = {
  nombres:          "",
  apellidos:        "",
  cedula:           "",
  telefono:         "",
  email:            "",
  puestoId:         "",
  tipoPersonal:     "administrativo",
  tipoContratacion: "nomina",
  fechaIngreso:     "",
  sueldoBase:       "",
  ruc:              "",
  estado:           "activo",
  observaciones:    "",
  docenteId:        null,
  usuarioId:        null,
};
